import React from 'react';
import classNames from 'classnames';
import { Input as AntdInput } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { TextAreaProps as AntdTextAreaProps } from 'antd/lib/input';

import cn from './styles.module.scss';

const { TextArea: AntdTextArea } = AntdInput;

export interface TextAreaProps extends AntdTextAreaProps {
  label?: string,
  error?: string,
}

export const TextArea = React.forwardRef(({
  className,
  error,
  prefix,
  onChange,
  value,
  label,
  name,
  ...props
}: TextAreaProps, ref) => (
  <div className={classNames(cn.inputContainer, className)}>
    {label && (
      <label htmlFor={name} className={cn.label}>{label}</label>
    )}
    <AntdTextArea
      className={classNames(cn.input,
        {
          [cn.error]: !!error,
          [cn.prefix]: !!prefix,
        })}
      prefix={prefix}
      name={name}
      ref={ref as any}
      onChange={onChange}
      value={value}
      {...props}
    />
    {!!error && (
      <div className={cn.errorContainer}>
        <ExclamationCircleFilled className={cn.icon} />
        {error}
      </div>
    )}
  </div>
));

TextArea.displayName = 'TextArea';
